







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DashboardSettingsBillingModalTitle extends Vue {
  @Prop() title!: string
  @Prop() subtitle!: string
}
